import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Loader } from 'src/shared/components/loader';
import { MainLayout } from 'src/shared/layouts/main-layout/main-layout';
import { useStore } from 'src/store';

import { Dashboard } from './features/dashboard/dashboard';
import { DashboardStore } from './features/dashboard/dashboard.store';

export const DashboardPage: FC = observer(function DashboardPage() {
  const { t } = useTranslation('dashboard');

  const rootStore = useStore();
  const { planVersion } = rootStore;

  const [dashbaordStore] = useState(() => new DashboardStore(rootStore));

  const isLoading = planVersion.isLoading || dashbaordStore.isLoading;

  useEffect(() => {
    dashbaordStore.init();
  }, [dashbaordStore]);

  const renderContent = () => {
    if (isLoading) {
      return <Loader size="large" />;
    }

    return <Dashboard store={dashbaordStore} />;
  };

  return <MainLayout title={t('Title')}>{renderContent()}</MainLayout>;
});
